// frontend/src/components/DateRangePicker.js
import React, { useState, useEffect } from 'react';
import { FiCalendar } from 'react-icons/fi';

const DateRangePicker = ({ onDateChange }) => {
  const [dateRange, setDateRange] = useState('today');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    handleDateRangeChange('today');
  }, []);

  const handleDateRangeChange = (range) => {
    setDateRange(range);
    const today = new Date();
    let start, end;

    switch (range) {
      case 'today':
        start = end = today.toISOString().split('T')[0];
        break;
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        start = end = yesterday.toISOString().split('T')[0];
        break;
      case 'week':
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() - 7);
        start = weekStart.toISOString().split('T')[0];
        end = today.toISOString().split('T')[0];
        break;
      case 'month':
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        start = monthStart.toISOString().split('T')[0];
        end = today.toISOString().split('T')[0];
        break;
      case 'custom':
        return;
      default:
        start = end = today.toISOString().split('T')[0];
    }

    setStartDate(start);
    setEndDate(end);
    onDateChange(start, end);
  };

  const handleCustomDateSearch = () => {
    if (!startDate || !endDate) {
      return;
    }
    onDateChange(startDate, endDate);
  };

  return (
    <div className="card mb-6">
      <div className="flex items-center gap-2 mb-4">
        <FiCalendar className="text-gray-600" />
        <h3 className="font-semibold text-gray-900">Хугацаа сонгох</h3>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-6 gap-3 mb-4">
        <button
          onClick={() => handleDateRangeChange('today')}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            dateRange === 'today'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Өнөөдөр
        </button>
        <button
          onClick={() => handleDateRangeChange('yesterday')}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            dateRange === 'yesterday'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Өчигдөр
        </button>
        <button
          onClick={() => handleDateRangeChange('week')}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            dateRange === 'week'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          7 хоног
        </button>
        <button
          onClick={() => handleDateRangeChange('month')}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            dateRange === 'month'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Энэ сар
        </button>
        <button
          onClick={() => setDateRange('custom')}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            dateRange === 'custom'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Сонгох
        </button>
      </div>

      {dateRange === 'custom' && (
        <div className="flex items-end gap-3">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Эхлэх огноо
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="input"
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Дуусах огноо
            </label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="input"
            />
          </div>
          <button
            onClick={handleCustomDateSearch}
            className="btn btn-primary"
          >
            Хайх
          </button>
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;